import "./product-shipping-notes.scss";
import { sendDataLayerOnLinkClickEvent } from "jiffy-analytics";

document.addEventListener("DOMContentLoaded", () => {
  const linkLearnMore = document.querySelector(".js-product-notes-learn-more");

  if (!linkLearnMore) return;

  linkLearnMore.addEventListener("click", event => {
    sendDataLayerOnLinkClickEvent(event, {
      genericEvent: true,
      eventCategory: "UX",
      event: "PDP to Shipping”",
      eventLabel: "learn more disclaimer"
    });
  });
});
